import React from 'react';
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import Home from './pages/Home';
import QuestionStave from './pages/QuestionStave';
import Rhythm from "./pages/Rhythm";
import ViewQuestion from './pages/ViewQuestion';
import QuestionSelection from "./pages/QuestionSelection";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Home/>,
        errorElement: <div>404</div>
    },
    {
        path: "/v1/app/question",
        element: <QuestionStave/>
    },
    {
        path: "/v1/app/question/view",
        element: <ViewQuestion/>
    },
    // 节奏部分技术储备
    {
        path: "/v1/app/rhythm",
        element: <Rhythm/>
    },
    {
        path: "/v1/app/question/selection",
        element: <QuestionSelection/>
    }
]);

const App = () => {
    return (
        <RouterProvider router={router}/>
    );
};

export default App;


export const testBuild = () => {
}
